import React from 'react';

const Layout = ({ children }) => {
  return <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">{children}</div>;
};

export default Layout;
